export default __webpack_public_path__ + "static/media/Member_genChangHsu.ce809976.jpg";